import publicationVisibilityStatuses from '../services/ElasticSearch/publicationVisibilityStatuses';

export default publicationVisibilityStatuses.getEnum();
